import React, { useState, useRef, useEffect } from "react";
import "./Ecosystem.css";
import ntrading from "../Assets/ash.png";

import Transcation from "../Utility/Utility";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Ecosystem() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  const scrollContainerRef = useRef(null);

  const [isDisabled, setDisabled] = useState(true);

  const handleScroll = () => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      const scrollTop = scrollContainer.scrollTop;
      const translateY = -scrollTop / 2;
      scrollContainer.style.transform = `translateY(${translateY}px)`;
    }
  };

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
      return () => {
        scrollContainer.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  return (
    <div className="scroll-container ease-out" ref={scrollContainerRef}>
      <div className="main_ecosysytem" id="ecosystem">
        <div className="container" style={{ marginTop: "70px" }} id="AboutUs">
          <div
            className="row align-items-center justify-content-center"
            data-aos="fade-up-right"
            data-aos-duration="3000"
          >
            <div className="col-md-5 order-mobile-first">
              <img className="pc-image" src={ntrading} alt="" />
            </div>
            <div className="col-md-5 order-mobile-second">
              {/* <p className="upper-text">Vision</p> */}
              <h6
                className="main-new-cursive"
                style={{ color: "#fff", marginTop: "10px" }}
              >
                Join the Presale and Secure Your Investment
              </h6>
              <div className="right_eco_content">
                <p className="text-dark">
                The piku Presale is your chance to become an early adopter of PIKUCOIN, the primary currency in the piku ecosystem. This presale offers a unique opportunity for investors to secure PIKUCOIN at a preferential price before its listing on major exchanges. With PIKUCOIN, you not only gain access to the piku gaming platform but also open doors to a promising long-term investment. Don't miss out on this chance to be part of a revolutionary gaming and blockchain experience.
                </p>
                <div style={{ marginTop: "20px" }}>
                  <a href="https://twitter.com/pikumeme" target="_blank">
                    <button className="button-5">Join Twitter </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <Transcation></Transcation>
        </div>
      </div>
    </div>
  );
}
